import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import './contact-success-page.scss';

export default class ContactSuccessPage extends Component {
  render() {
    return (
      <div className="inscriereSuccess error-page-sec pt-100 pb-100">
        <div className="container">
          <div className="row">
            <div className="col-md-3" />
            <div className="col-md-6">
              <div className="error-page-content">
                <h1>Multumim</h1>
                <h2>Mesajul dumneavoastra a fost trimis cu success</h2>
                <div className="inscriereSuccess-icon fa fa-check-circle" />
                <Link to="/">Inapoi la site</Link>
              </div>
            </div>
            <div className="col-md-3" />
          </div>
        </div>
      </div>
    );
  }
}
